module.exports = __webpack_public_path__ + "images/emoji/bullettrain_side.536aefb61b7bf3d29fd8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/bullettrain_side.png
// module id = 14B6
// module chunks = 13